// Converte '2001-12-15' => '15/12/2001'
export const formatarDataParaBR = (iso: string): string => {
  if (!iso) return '';
  const [ano, mes, dia] = iso.split('-');
  return `${dia}/${mes}/${ano}`;
};

// Converte '15/12/2001' => '2001-12-15'
export const formatarDataParaISO = (dataBr: string): string => {
  const [dia, mes, ano] = dataBr.split('/');
  if (!dia || !mes || !ano) return '';
  return `${ano}-${mes}-${dia}`;
};


export const dataBrEhValida = (data: string): boolean => {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(data)) return false;

  const [dia, mes, ano] = data.split('/').map(Number);
  const dataDate = new Date(`${ano}-${mes}-${dia}`);

  return (
    dataDate.getFullYear() === ano &&
    dataDate.getMonth() + 1 === mes &&
    dataDate.getDate() === dia
  );
};
